import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentRibbonFilled: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M17.002 15.244L17 21.245a.75.75 0 01-1.182.613L12 19.171l-3.817 2.687a.75.75 0 01-1.181-.613l-.002-6A7.966 7.966 0 0012 17a7.966 7.966 0 005.002-1.756zM12 2a7 7 0 110 14 7 7 0 010-14z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentRibbonFilled
